import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../../components/auth/auth.service';
import * as $ from 'jquery';
import { MainMenuService } from '../../main/services/menuservice.service';
import { AppServiceService } from '../../main/services/product.service';
import { Subscription } from 'rxjs';
import { UtilityService } from '../../shared/services/Utility.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import Swal from 'sweetalert2';
var moment = require('moment');

interface User {
    name: string;
    email: string;
    password: string;
    mode: string;
}
@Component({
    selector: 'login',
    template: require('./login.html'),
    // styles: [require('./login.component.css')],
})
export class LoginComponent implements OnInit {
    public navbar: boolean = false;
    user: User = {
        name: '',
        email: '',
        password: '',
        mode: '',
    };
    errors = { login: undefined };
    submitted = false;
    AuthService;
    isLoggedIn;
    Router;
    busy: Subscription;
    private userObj: any;
    type: any;
     toast = Swal.mixin({
        toast: true,
        position: 'center',
        showConfirmButton: false,
        timer: 2000,
        // backdrop: `rgba(30, 30, 37, 0.4)`
    });

    toastWarningMsg(msg) {
      this.toast({
          type: 'warning',
          title: msg,
          timer: 6000
      });
  }
    //currentUser;
    static parameters = [AuthService, Router, MainMenuService, AppServiceService, ActivatedRoute, UtilityService, HttpClient];
    constructor(_AuthService_: AuthService, router: Router, private _MenuService: MainMenuService, private _AppServiceService: AppServiceService, private _ActivatedRoute: ActivatedRoute, private _UtilityService: UtilityService, private http: HttpClient) {
        this.AuthService = _AuthService_;
        this.Router = router;
        this.http = http;
    }

    ngOnInit() {
        $('#email').focus();
        this.AuthService.isLoggedIn().then(is => {
          this.isLoggedIn = is;
          if (this.isLoggedIn) {
            if(this._MenuService.isMRUser) {
              this.Router.navigateByUrl('/mrlogin');
              return;
            }
            this.Router.navigateByUrl('/home');
          } else {
            this.Router.navigateByUrl('/login');
          }
        });
      }

    f_ChkNum(p_value) {
        var Num = Number(p_value);
        if (Num) {
            return Num;
        }
        return 0;
    }

    async ERPlogin() {
      this.errors.login = '';
        this.busy = new Subscription();
        try {
          this.AuthService.IsMRLogin = 0;
          const response = await this.AuthService.login({
            email: this.user.email,
            password: this.user.password
          });
          this.busy.closed = true;
          this._AppServiceService.OnDashboardDataLoad();
          this._MenuService.UserPermissionSetter();
          this._MenuService.MenuListSetter(response._id);
          this._AppServiceService.GetUnitFyearData(response._id);
          let data = { user_ID: response._id };
          this.AuthService.GetSystemConfigDetails(data);
          if (response.isDummyPwd == true || response.isDummyPwd == 1) {
            this.Router.navigateByUrl('/changepassword');
            // this.Router.navigateByUrl('/settings');
          }

          else if (await this.checkExpDate() == false) {
            this.toastWarningMsg("Password has been expired. Please reset your password.");
            localStorage.setItem('password_policy_change', '1');
            this.Router.navigateByUrl('/changepassword');
            // this.logout();
            return;
          }

          else {
            var status = this.passwordValidate();
            if (!status) {
              // setTimeout(() => { $("input[name=password]").focus(); }, 100);
              localStorage.setItem('password_policy_change', '1');
              this.toastWarningMsg("Unable to login, password policy has been changed." + '<br>' + "Please reset your password.");
              // this.logout();
              // return;
              this.Router.navigateByUrl('/changepassword');

            }

            else {
              this.Router.navigateByUrl('/home');
              if (localStorage.getItem('password_policy_change')) {
                localStorage.removeItem('password_policy_change');
              }
            }
          }
        } catch (err) {
          this.busy.closed = true;
          this.errors.login = err.error.message;
        }
      }
    
      async MRModuleLogin() {
        this.busy = new Subscription();
        try {
          this.AuthService.IsMRLogin = 1;
          const response = await this.AuthService.MRlogin({
            email: this.user.email,
            password: this.user.password,
          })
          this.busy.closed = true;
          this.Router.navigateByUrl('/mrlogin');
        } catch (err) {
          this.busy.closed = true;
          this.errors.login = err.error.message;
        }
      }
    
      login(form: { invalid: any }) {
        var emailpattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        var emailid = this.user.email;
        if (form.invalid) return;
        if (emailid.search(emailpattern) == -1) {
          this.ERPlogin();
        } else {
          this.MRModuleLogin();
        }
    
      }

    goForgotPassword() {
        this.Router.navigateByUrl(['/forgotpassword']);
    }

    movenext(e) {
        if (e.which == 13) {
            $('#password').focus();
        }
    };

    movenext1(e) {
        if (e.which == 13) {
            $('#okbtn').focus();
        }
    };

    per: any;
    logout() {
      var per = JSON.parse(localStorage.getItem('permission'))[0];
      this.http.post('/api/users/RemoveLoggedInTime', { "UserId": per["_id"] })
          .subscribe(response => {
              return this.AuthService.logout().then(() => {
                  this.Router.navigateByUrl('/login');
                  localStorage.clear();
                  this.reset();
                  this._AppServiceService.getFooterDetails();
                  this._AppServiceService.footerDataSubject.next(null);
                  this._AppServiceService.OnDashboardDataLoad();
                  setTimeout(() => {
                      this._AppServiceService.footerDataTable.subscribe(res => {
                          this.per = res;
                      });
                  }, 600);
              });
          });
  };

  isAdmin: any;
  currentUser: any;
  reset() {
    this.userObj = {};
    this.type = {};
    this.AuthService.isLoggedIn().then(is => {
        this.isLoggedIn = is;
    });
    this.AuthService.isAdmin().then(is => {
        this.isAdmin = is;
    });
    this.AuthService.getCurrentUser().then(user => {
        this.currentUser = user;
    });
    setTimeout(() => {
        if (localStorage.getItem('user') && localStorage.getItem('permission')) {
            this.userObj = JSON.parse(localStorage.getItem('user'));
            this.type = JSON.parse(localStorage.getItem('permission'))[0];
        }
    }, 1000);
};

  f_check_string(p_value) {
    var Val = (p_value ? p_value.toString() : "").trim();
    return Val;
  };

  passwordValidate(){
        if(!this.user.password){
            return;
        }

        var password = this.user.password;
        if (password.length < 8) {
            return false;
        }
    
        var specialCharPattern = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
        var uppercasePattern = /[A-Z]/;
        var numericPattern = /[0-9]/;
    
        if (this.f_check_string(password.search(specialCharPattern) == -1)) {
            return false;
        }
    
        if (this.f_check_string(password.search(uppercasePattern) == -1)) {
            return false;
        }
    
        if (this.f_check_string(password.search(numericPattern) == -1)) {
            return false;
        }
        return true;
    };

  checkExpDate(): Promise<boolean> {
    return new Promise<boolean>(async (resolve, reject) => {
      var permission = await JSON.parse(localStorage.getItem('permission'))[0];
      console.log('🚀 ~ permission:', permission)
      let expDate = permission['Emp_Password_Expiry_Date'];
      let role_ID = permission['Roll_ID'];
      let today = moment(new Date()).format('YYYY-MM-DD');
      console.log('🚀 ~ today:', today)
      let expiryDate = moment(expDate).format('YYYY-MM-DD');
      console.log('🚀 ~ expiryDate:', expiryDate)

      if (today > expiryDate && role_ID != 4) {
        resolve(false);
      } else {
        resolve(true);
      }
    });
  }
}
